import { render, staticRenderFns } from "./CardPermission.vue?vue&type=template&id=041367ee&scoped=true&"
import script from "./CardPermission.vue?vue&type=script&lang=js&"
export * from "./CardPermission.vue?vue&type=script&lang=js&"
import style0 from "./CardPermission.vue?vue&type=style&index=0&id=041367ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041367ee",
  null
  
)

export default component.exports